var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#6756FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_82329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_82329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 11.5443C18.1806 11.5443 18.3299 11.4852 18.4479 11.3672C18.566 11.2491 18.625 11.0998 18.625 10.9193C18.625 10.7387 18.566 10.5894 18.4479 10.4714C18.3299 10.3533 18.1806 10.2943 18 10.2943C17.8194 10.2943 17.6701 10.3533 17.5521 10.4714C17.434 10.5894 17.375 10.7387 17.375 10.9193C17.375 11.0998 17.434 11.2491 17.5521 11.3672C17.6701 11.4852 17.8194 11.5443 18 11.5443ZM23 27.1693C21.8472 27.1693 20.8646 26.763 20.0521 25.9505C19.2396 25.138 18.8333 24.1554 18.8333 23.0026C18.8333 21.8498 19.2396 20.8672 20.0521 20.0547C20.8646 19.2422 21.8472 18.8359 23 18.8359C24.1528 18.8359 25.1354 19.2422 25.9479 20.0547C26.7604 20.8672 27.1667 21.8498 27.1667 23.0026C27.1667 24.1554 26.7604 25.138 25.9479 25.9505C25.1354 26.763 24.1528 27.1693 23 27.1693ZM22.5833 25.5026H23.4167V23.4193H25.5V22.5859H23.4167V20.5026H22.5833V22.5859H20.5V23.4193H22.5833V25.5026ZM13.8333 15.5026H22.1667V13.8359H13.8333V15.5026ZM17.7292 25.5026H12.1667C11.7083 25.5026 11.316 25.3394 10.9896 25.013C10.6632 24.6866 10.5 24.2943 10.5 23.8359V12.1693C10.5 11.7109 10.6632 11.3186 10.9896 10.9922C11.316 10.6658 11.7083 10.5026 12.1667 10.5026H15.6667C15.8472 10.0026 16.1493 9.59983 16.5729 9.29427C16.9965 8.98872 17.4722 8.83594 18 8.83594C18.5278 8.83594 19.0035 8.98872 19.4271 9.29427C19.8507 9.59983 20.1528 10.0026 20.3333 10.5026H23.8333C24.2917 10.5026 24.684 10.6658 25.0104 10.9922C25.3368 11.3186 25.5 11.7109 25.5 12.1693V17.7526C25.0972 17.5582 24.691 17.4123 24.2812 17.3151C23.8715 17.2179 23.4444 17.1693 23 17.1693C22.8472 17.1693 22.7049 17.1727 22.5729 17.1797C22.441 17.1866 22.3056 17.204 22.1667 17.2318V17.1693H13.8333V18.8359H18.9375C18.6875 19.072 18.4618 19.329 18.2604 19.6068C18.059 19.8845 17.8819 20.1832 17.7292 20.5026H13.8333V22.1693H17.2292C17.2014 22.3082 17.184 22.4436 17.1771 22.5755C17.1701 22.7075 17.1667 22.8498 17.1667 23.0026C17.1667 23.4609 17.2083 23.888 17.2917 24.2839C17.375 24.6797 17.5208 25.0859 17.7292 25.5026Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.80eda322db909da1592fedc2ecab57c1.svg";
export { ForwardRef as ReactComponent };